const commonUtility = require('./commonUtility');
const stringUtil = require("../string/stringUtil");
const constants = require("./constants");
const arraySort = require("array-sort");


module.exports.attributes = {
    code: "code",
    name: "name", 
    language: "language", 
    currency: "currency",
    currencySymbol: "currencySymbol",
    currencyDisplay: "currencyDisplay",
    vatCaption: "vatCaption",
    vatPercentage: "vatPercentage",
    isVatInclusive: "isVatInclusive",
    isVatApplicable: "isVatApplicable",
    phoneNumberValidator: "phoneNumberValidator",
    doPrintUnitPriceInSaleReceipt: "doPrintUnitPriceInSaleReceipt",
    currencyDenominations: "currencyDenominations",
    supportEmail: "supportEmail",
    supportPhone: "supportPhone",
    supportWhatsapp: "supportWhatsapp",
    operativeVatBands: "operativeVatBands"
}

function getLocalValue(attribute)
{
    const localizationSettings = commonUtility.getPropertyResolvedLocationSettings();
    return localizationSettings[attribute];
}

module.exports.getCurrentCurrencyFormatter = function ()
{
    const language = getLocalValue(this.attributes.language);
    const currency = getLocalValue(this.attributes.currency);
    const currencyDisplay = getLocalValue(this.attributes.currencyDisplay);

    const options = {
        style: "currency",
        currency: currency,
        currencyDisplay: currencyDisplay,
        minimumFractionDigits: 2
    };

    return new Intl.NumberFormat(language, options);
}

module.exports.getVatCaption = function ()
{
    return getLocalValue(this.attributes.vatCaption)
}

module.exports.getCurrency = function()
{
    return getLocalValue(this.attributes.currency);
}

module.exports.getCurrencySymbol = function()
{
    return getLocalValue(this.attributes.currencySymbol);
}

module.exports.isVatInclusive = function()
{
    return getLocalValue(this.attributes.isVatInclusive);
}

module.exports.isVatApplicable = function()
{
    return getLocalValue(this.attributes.isVatApplicable);
}

module.exports.getVatPercentage = function()
{
    return getLocalValue(this.attributes.vatPercentage);
}

module.exports.getSupportPhoneNumber = function()
{
    return getLocalValue(this.attributes.supportPhone);
}

module.exports.getSupportWhatsAppNumber = function()
{
    return getLocalValue(this.attributes.supportWhatsapp);
}

module.exports.getSupportEmailAddress = function()
{
    return getLocalValue(this.attributes.supportEmail);
}

module.exports.getLanguage = function ()
{
    return getLocalValue(this.attributes.language);
}

module.exports.doPrintUnitPriceInSaleReceipt = function()
{
    return getLocalValue(this.attributes.doPrintUnitPriceInSaleReceipt);
}

module.exports.getCountry = function ()
{
    return getLocalValue(this.attributes.name)
}

module.exports.getCurrencyDenominations = function()
{
    return getLocalValue(this.attributes.currencyDenominations);
}

module.exports.getOperativeVatBands = function ()
{
    return getLocalValue(this.attributes.operativeVatBands) || [];
}

module.exports.getApplicableVenues = function ()
{
    const allVenues = commonUtility.getVenues();

    const pakistanSpecificVenueCodes = [];
    const ukSpecificVenueCodes = [constants.VenueCodeDeliveroo, constants.VenueCodeJustEats, constants.VenueCodeUberEats, constants.VenueCodeFlipdish];
    const irelandSpecificVenueCodes = [constants.VenueCodeDeliveroo, constants.VenueCodeJustEats, constants.VenueCodeUberEats, constants.VenueCodeFlipdish];
    const kenyaSpecificVenueCodes = [];
    
    const pakistanVenues = allVenues.filter(venue => pakistanSpecificVenueCodes.includes(venue.code)); 
    const ukVenues = allVenues.filter(venue => ukSpecificVenueCodes.includes(venue.code)); 
    const irelandVenues = allVenues.filter(venue => irelandSpecificVenueCodes.includes(venue.code)); 
    const kenyaVenues = allVenues.filter(venue => kenyaSpecificVenueCodes.includes(venue.code)); 

    const genericVenues = allVenues.filter(venue => ![...pakistanSpecificVenueCodes, ...ukSpecificVenueCodes, ...irelandSpecificVenueCodes].includes(venue.code));

    const country = this.getCountry();
    if (stringUtil.areStringSame(country, "Pakistan"))
        return arraySort(genericVenues.concat(pakistanVenues), "code");
    
    if (stringUtil.areStringSame(country, "UK"))
        return arraySort(genericVenues.concat(ukVenues), "code");
    
    if (stringUtil.areStringSame(country, "Ireland"))
        return arraySort(genericVenues.concat(irelandVenues), "code");
    
    if (stringUtil.areStringSame(country, "Kenya"))
        return arraySort(genericVenues.concat(kenyaVenues), "code");

    return allVenues;
}